import {AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {Router} from '@angular/router';
import {PublicationModel, PublicationPageAbleModel} from '../../models/publication.model';
import {LanguageModel} from '../../models/language.model';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {UserModel} from '../../models/user.model';
import * as moment from 'moment';
import {ConfirmationService} from 'primeng/api';
import {I18nService} from '../../../shared/i18n';
import {PublicationService} from '../../services/publication.service';
import {NotificationService} from '../../../shared/utils/notification.service';
import {AppCommunicationService} from '../../services/app-communication.service';
import {PublicationQueryModel} from '../../models/query.model';
import {DataTable} from 'primeng/primeng';

@Component({
  selector: 'app-my-publication-view',
  templateUrl: './my-publication-view.component.html',
  styleUrls: ['./my-publication-view.component.scss']
})
export class MyPublicationViewComponent implements OnInit {

    publications: PublicationModel[] = [];

    pTable = {
        colNumber: 6,
        expandedRows: {}
    };
    yearFilter = {
        data: [],
        settings: {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Označiť všetko',
            unSelectAllText: 'Odznačiť všetko',
            itemsShowLimit: 2,
            allowSearchFilter: false
        }
    };
    loading = true;
    filter = {
        search: '',
        year: [],
        page:1,
        pageSize:15,
        totalItems: 1
    };
    message='';

    @ViewChild('dt') dataTable: DataTable;
    constructor(private router: Router,
                private _notificationService: NotificationService,
                private confirmationService: ConfirmationService,
                private i18nService: I18nService,
                private publicationService:PublicationService,
                private notificationService:NotificationService,
                private _appCommunicationService: AppCommunicationService
                ) {
        this.generateYearsFilter();
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        let timeout = null;
        const textInput = <HTMLInputElement>document.getElementById('search');
        textInput.onkeyup = () => {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                this.filter.search = textInput.value;
                if(this.filter.search.length === 0 || this.filter.search.length > 2) {
                    this.filterData();
                }
            }, 500)
        }
    }

    setPage(pageInfo) {
        this.filter.page = (pageInfo.first + pageInfo.rows) / 15;
        this.filterData(false);
    }

    filterData(resetPagination = true) {

        this.loading=true;
        if(resetPagination) {
            this.dataTable.first=0;
        }
        const publicationquery = new PublicationQueryModel();
        publicationquery.years =  this.filter.year.map(year => year.item_id );
        resetPagination ? publicationquery.page=1 : publicationquery.page= this.filter.page;
        publicationquery.pageSize= this.filter.pageSize;
        publicationquery.searchText=this.filter.search;

        this.publicationService.getMyPublications(publicationquery).subscribe((data:PublicationPageAbleModel)=> {
            this.loading = false;
            this.publications=data.items;
            this.filter.totalItems=data.totalItems;
        },err=> {
            this.loading = false;
            console.error(err);
        })
    }
    onSelectAllYears(value) {
        this.filter.year.push(value.map(y=>y.item_id));
        this.filterData();
    }


    onDeselectAllYears() {
        this.filter.year = [];
        this.filterData();
    }


    generateYearsFilter() {
        let initYear = Number.parseInt(moment(Date.now()).format('YYYY'));
        const endYear = 2010;

        while (initYear >= endYear) {
            this.yearFilter.data.push({
                item_id: initYear,
                item_text: initYear.toString()
            });
            if (initYear === Number.parseInt(moment(Date.now()).format('YYYY'))) {
                this.filter.year.push({
                    item_id: initYear,
                    item_text: initYear.toString()
                });
            }
            initYear--;
        }
    }

    redirectToNewRegistration() {
        this.router.navigate(['/publication/registration']);
    }
    onDeleteApply(publication) {
        this._notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmDeleteApply'),
            buttons: '['+this.i18nService.getTranslation('No')+']['+
            this.i18nService.getTranslation('Yes')+']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes') ) {
                this.publicationService.deleteMyUntouchedPublications(publication.id).subscribe(()=> {
                    this.filterData(false);
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('removed'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('PublicationHasBeenRemoved'),
                        timeout: 10000
                    });
                },(err)=> {
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 5000
                    });
                    console.error(err);
                })
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/my-publication-view/my-publication-view.component.ts